import { render, staticRenderFns } from "./PagesGiftWrappersWidget.vue?vue&type=template&id=35861a93&"
import script from "./PagesGiftWrappersWidget.vue?vue&type=script&lang=js&"
export * from "./PagesGiftWrappersWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports